import React, { useEffect } from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getCourseList, courseSearch, courseRegister } from "../../redux/actions/CourseActions"
import { CircularProgress } from '@material-ui/core';
import { Helmet } from "react-helmet";
import { getAdsList } from "../../redux/actions/admin/AdsActions";
import { NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { DropzoneArea } from 'material-ui-dropzone';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import CustomAlert from '../shared/views/CustomAlert';
import { CategoryBannerHelper } from '../shared/CategoryBanners';
import isMatch from 'date-fns/isMatch'
import validator from 'validator'
import Select from 'react-select';
import siteService from '../../services/siteService';
import localStorageService from "../../services/localStorageService";

const useStyles = makeStyles(theme => createStyles({
    previewChip: {
        minWidth: 160,
        maxWidth: 210
    },
}));

export const CourseDetail = (props) => {
    const {
        courseSearch,
        getAdsList,
        courseRegister,
        storeAds,
        storeCourse = {},

    } = props;

    const classes = useStyles();

    const [isLoading, setIsLoading] = React.useState(true);
    const [isSaving, setIsSaving] = React.useState(false);
    const [postulated, setPostulated] = React.useState(false);
    const [hasAdditionalQuestions, setHasAdditionalQuestions] = React.useState(false);
    const [hasMissingValue, setHasMissingValue] = React.useState(true);
    const [course, setCourse] = React.useState(null);
    const [courseNumber, setCourseNumber] = React.useState("");
    const [displayingActiveAdsList, setDisplayingActiveAdsList] = React.useState([]);
    const [selectedFiles, setSelectedFiles] = React.useState([]);
    const [candidateInformation, setCandidateInformation] = React.useState({
        id: "",
        candidateId: "",
        title: "",
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber1: "",
        phoneNumber2: "",
        jobTitle: "",
        companyName: "",
        paymentMethod: ""

    });
    const [invalideEmail, setInvalideEmail] = React.useState(false);
    const [additionalQuestions, setAdditionalQuestions] = React.useState([]);
    const currentSite = siteService.getCurrentSite();

    useEffect(() => {
        let match = props.match;
        if (match !== undefined) {
            let params = match.params;
            if (params !== undefined && params.courseNumber !== undefined) {
                setCourseNumber(params.courseNumber);
            }
        };
        if (storeAds.adsList.length == 0) {
            getAdsList(false).then(resp => {
                setDisplayingActiveAdsList(resp.adsList);
            })
        }
        else {
            setDisplayingActiveAdsList(storeAds.adsList);
        }
        let candidate = localStorageService.getItem("malibaara_auth_candidate");
        if (candidate) {
            setCandidateInformation(prevState => {
                return {
                    ...prevState,
                    candidateId: candidate.id,
                    firstName: candidate.firstName,
                    lastName: candidate.lastName,
                    email: candidate.email,
                    phoneNumber1: candidate.phoneNumber1,
                    phoneNumber2: candidate.phoneNumber2
                }
            });
        }

    }, []);

    useEffect(() => {
        if (courseNumber != "") {
            if (storeCourse.courseListIncludedDescription.length == 0 && course === null) {
                courseSearch(true).then(response => {
                    if (response) {
                        let courseFromrequest = response.documents.find(d => d.courseNumber == courseNumber);
                        if (courseFromrequest) {
                            setCourse(courseFromrequest);
                            setCandidateInformation(prevState => { return { ...prevState, id: courseFromrequest.courseId } });
                            if (courseFromrequest?.hasAdditionalQuestions == true) {
                                setHasAdditionalQuestions(true);
                            }
                        }
                    }
                })
            }
            else if (storeCourse.courseListIncludedDescription.length > 0 && course === null) {
                let courseFromrequest = storeCourse.courseListIncludedDescription.find(d => d.courseNumber == courseNumber);
                if (courseFromrequest) {
                    setCourse(courseFromrequest);
                    setCandidateInformation(prevState => { return { ...prevState, id: courseFromrequest.courseId } });
                    if (courseFromrequest?.hasAdditionalQuestions == true) {
                        setHasAdditionalQuestions(true);
                    }
                }
            }
        }
    }, [courseNumber]);

    useEffect(() => {
        if (course !== null && isLoading) {
            setIsLoading(false);
        }
    }, [course]);

    useEffect(() => {
        if (candidateInformation.firstName === undefined
            || candidateInformation.firstName == ""
            || candidateInformation.lastName === undefined
            || candidateInformation.lastName == ""
            || candidateInformation.email === undefined
            || candidateInformation.email == ""
        ) {
            setHasMissingValue(true);
        }
        else if (candidateInformation?.firstName?.length > 50
            || candidateInformation?.lastName?.length > 50
            || candidateInformation?.phoneNumber1?.length > 50
            || candidateInformation?.phoneNumber2?.length > 50
            || candidateInformation?.email?.length > 50
            || (candidateInformation?.phoneNumber1 != "" && !(new RegExp(/^[0-9\b]+$/)).test(candidateInformation?.phoneNumber1))
            || (candidateInformation?.phoneNumber2 != "" && !(new RegExp(/^[0-9\b]+$/)).test(candidateInformation?.phoneNumber2))
            || (candidateInformation?.email != "" && !validator.isEmail(candidateInformation?.email))
        ) {
            setHasMissingValue(true);
        }
        else {
            setHasMissingValue(false);
        }
    }, [candidateInformation, selectedFiles])

    let handleSubmit = () => {
        setIsSaving(true);
        let value = candidateInformation;
        courseRegister(candidateInformation).then(resp => {
            if (resp) {
                setIsSaving(false);
                setPostulated(true)
            }
        });
    }


    return (
        <>
            <React.Fragment>

                {isLoading ? (
                    <div className="loading-container">
                        <CircularProgress />
                        <div>Chargement du formulaire de postulation en cours...</div>
                    </div>
                ) : (
                    <>
                        <Helmet>
                            <title>Postulation à une offre d'emploi | {course.title}  | {currentSite.fullName}</title>
                        </Helmet>
                        <div className={"header-inner category-header category-" + course.category} style={{ background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${CategoryBannerHelper.getLevel(course.category)})` }}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-12">
                                        <h2 style={{ color: "white" }}>{course.title}</h2>
                                        <ol className="breadcrumb mb-0 p-0">
                                            <li className="breadcrumb-item"><NavLink tag={Link} to="/">Accueil</NavLink></li>
                                            <li className="breadcrumb-item"><i className="fas fa-chevron-right"></i><NavLink tag={Link} to="/courses/search">Offres d'emploi</NavLink></li>
                                            <li className="breadcrumb-item"><i className="fas fa-chevron-right"></i><NavLink tag={Link} to={"/courses/details/" + course.courseNumber}>{course.courseNumber}</NavLink></li>
                                            <li className="breadcrumb-item active"> <i className="fas fa-chevron-right"></i> <span> Postulation </span></li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <section className="space-ptb" style={{ paddingTop: "40px" }}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-xl-8">
                                        <div className="bg-light-3 p-4">
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="section-title">
                                                        <h2 className="title"><span>Formulaire de postulation</span></h2>
                                                        <p>Veuillez remplir le formulaire ci-dessous pour postuler à cette offre d'emploi:</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div _lpchecked="1">
                                                <div className="form-row">
                                                    <div className="form-group col-md-12">
                                                        <label>Civilité</label>
                                                        <Select
                                                            // ref={companyNameSelectInputRef}
                                                            options={[{ label: "Mr", value: "Mr" }, { label: "Mme", value: "Mme" }]}
                                                            loadingMessage="En cours de chargement"
                                                            onChange={(option) => {
                                                                setCandidateInformation(prevState => { return { ...prevState, title: option?.value } });
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="form-group col-md-12">
                                                        <label>Prénom *</label>
                                                        <input
                                                            value={candidateInformation?.firstName}
                                                            type="text"
                                                            className="form-control"
                                                            name="firstName"
                                                            onChange={(e) => {
                                                                let val = e.target?.value;
                                                                setCandidateInformation(prevState => { return { ...prevState, firstName: val } });
                                                            }}
                                                            placeholder=""
                                                            disabled={postulated}
                                                        />
                                                        {candidateInformation?.firstName?.length > 50 && (
                                                            <p style={{ color: "red" }}>le nombre maximum de caractères a été dépassé</p>
                                                        )}
                                                    </div>
                                                    <div className="form-group col-md-12">
                                                        <label>Nom *</label>
                                                        <input
                                                            value={candidateInformation?.lastName}
                                                            type="text"
                                                            className="form-control"
                                                            name="lastName"
                                                            onChange={(e) => {
                                                                let val = e.target?.value;
                                                                setCandidateInformation(prevState => { return { ...prevState, lastName: val } });
                                                            }}
                                                            placeholder=""
                                                            disabled={postulated}
                                                        />
                                                        {candidateInformation?.lastName.length > 50 && (
                                                            <p style={{ color: "red" }}>le nombre maximum de caractères a été dépassé</p>
                                                        )}
                                                    </div>
                                                    <div className="form-group col-md-12">
                                                        <label>Addresse email *</label>
                                                        <input
                                                            value={candidateInformation?.email}
                                                            type="text"
                                                            className="form-control"
                                                            name="email"
                                                            onChange={(e) => {
                                                                let val = e.target?.value;
                                                                let isValide = validator.isEmail(e.target.value);
                                                                setCandidateInformation(prevState => { return { ...prevState, email: val } });
                                                                if (invalideEmail) {
                                                                    setInvalideEmail(!isValide);
                                                                }
                                                            }}
                                                            onBlur={(e) => {
                                                                let val = validator.isEmail(e.target.value);
                                                                setInvalideEmail(!val);
                                                            }}
                                                            placeholder=""
                                                            disabled={postulated}
                                                        />
                                                        {candidateInformation?.email?.length > 50 && (
                                                            <p style={{ color: "red" }}>le nombre maximum de caractères a été dépassé</p>
                                                        )}
                                                        {(candidateInformation?.email != "" && invalideEmail) && (
                                                            <p style={{ color: "red" }}>Format d'email invalide</p>
                                                        )}
                                                    </div>
                                                    <div className="form-group col-md-6" >
                                                        <label>Numéro de téléphone</label>
                                                        <input
                                                            value={candidateInformation?.phoneNumber1}
                                                            type="text"
                                                            className="form-control"
                                                            name="phoneNumber1"
                                                            onChange={(e) => {
                                                                let val = e.target?.value;
                                                                setCandidateInformation(prevState => { return { ...prevState, phoneNumber1: val } });
                                                            }}
                                                            disabled={postulated}
                                                        />
                                                        {candidateInformation?.phoneNumber1.length > 50 && (
                                                            <p style={{ color: "red" }}>le nombre maximum de caractères a été dépassé</p>
                                                        )}
                                                        {(candidateInformation?.phoneNumber1 != "" && !(new RegExp(/^[0-9\b]+$/)).test(candidateInformation?.phoneNumber1)) && (
                                                            <p style={{ color: "red" }}>Format invalide</p>
                                                        )}
                                                    </div>
                                                    <div className="form-group col-md-6">
                                                        <label>Autre numéro de téléphone</label>
                                                        <input
                                                            value={candidateInformation?.phoneNumber2}
                                                            type="text"
                                                            className="form-control"
                                                            name="phoneNumber2"
                                                            onChange={(e) => {
                                                                let val = e.target?.value;
                                                                setCandidateInformation(prevState => { return { ...prevState, phoneNumber2: val } });
                                                            }}
                                                            disabled={postulated}
                                                        />
                                                        {candidateInformation?.phoneNumber2.length > 50 && (
                                                            <p style={{ color: "red" }}>le nombre maximum de caractères a été dépassé</p>
                                                        )}
                                                        {(candidateInformation?.phoneNumber2 != "" && !(new RegExp(/^[0-9\b]+$/)).test(candidateInformation?.phoneNumber2)) && (
                                                            <p style={{ color: "red" }}>Format invalide</p>
                                                        )}
                                                    </div>
                                                    <div className="form-group col-md-12">
                                                        <label>Fonction</label>
                                                        <input
                                                            value={candidateInformation?.jobTitle}
                                                            type="text"
                                                            className="form-control"
                                                            name="jobTitle"
                                                            onChange={(e) => {
                                                                let val = e.target?.value;
                                                                setCandidateInformation(prevState => { return { ...prevState, jobTitle: val } });
                                                            }}
                                                            disabled={postulated}
                                                        />
                                                        {candidateInformation?.jobTitle?.length > 50 && (
                                                            <p style={{ color: "red" }}>le nombre maximum de caractères a été dépassé</p>
                                                        )}
                                                    </div>
                                                    <div className="form-group col-md-12">
                                                        <label>Entreprise</label>
                                                        <input
                                                            value={candidateInformation?.companyName}
                                                            type="text"
                                                            className="form-control"
                                                            name="companyName"
                                                            onChange={(e) => {
                                                                let val = e.target?.value;
                                                                setCandidateInformation(prevState => { return { ...prevState, companyName: val } });
                                                            }}
                                                            disabled={postulated}
                                                        />
                                                        {candidateInformation?.companyName?.length > 50 && (
                                                            <p style={{ color: "red" }}>le nombre maximum de caractères a été dépassé</p>
                                                        )}
                                                    </div>
                                                    <div className="form-group col-md-12">
                                                        <label>Mode de paiement</label>
                                                        <Select
                                                            // ref={companyNameSelectInputRef}
                                                            options={[{ label: "Orange Money", value: "orangeMoney" }, { label: "Moov Money", value: "moovMoney" }]}
                                                            loadingMessage="En cours de chargement"
                                                            onChange={(option) => {
                                                                setCandidateInformation(prevState => { return { ...prevState, paymentMethod: option?.value } });
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="col-12 mt-4">
                                                        <button
                                                            className="btn btn-primary"
                                                            onClick={handleSubmit}
                                                            disabled={isSaving || hasMissingValue || postulated}
                                                        >
                                                            S'inscrire &nbsp;
                                                            {isSaving ? <CircularProgress size={15} /> : <span></span>}
                                                        </button>
                                                    </div>
                                                    {postulated && (
                                                        <div className="col-12 mt-4">
                                                            <CustomAlert content="<strong>Félicitations!</strong> votre inscription s'est passé avec succès, un membre de Malibaara va vous contacter" />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-4">
                                        <div className="sidebar mb-0">
                                            <div className="widget">
                                                <div className="company-address widget-box">
                                                    <div className="company-address-map text-center">
                                                        <img className="img-fluid" src={course.imageUrl != "" ? course.imageUrl : "assets/images/default-course.png"} alt="" />
                                                    </div>
                                                    <ul className="list-unstyled mt-3">
                                                        <li><a href={`tel:${course.companyPhoneNumber1Contact}`}><i className="fas fa-phone fa-flip-horizontal fa-fw"></i><span className="pl-2">{course.companyPhoneNumber1Contact} {course.companyPhoneNumber2Contact}</span></a></li>
                                                        <li><a href={`mailto:${course.companyEmailContact}`}><i className="fas fa-envelope fa-fw"></i><span className="pl-2">{course.companyEmailContact}</span></a></li>
                                                        <li><a href="#"><i className="fas fa-link fa-fw"></i><span className="pl-2">Afficher toutes les offres</span></a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="widget border-0" style={{ marginTop: "30px" }}>
                                                <div className="coursester-company-view">
                                                    <ul className="list-unstyled">
                                                        {
                                                            displayingActiveAdsList.map((ads, index) => (
                                                                ads.attachments.map((attachment, index) => (
                                                                    <li>
                                                                        <div className="widget-box">
                                                                            <div className="d-flex">
                                                                                <div>
                                                                                    <a href={ads.link} target={ads.openInNewTab ? "_blank" : ""}>
                                                                                        {/* <p>{attachment.name}</p> */}
                                                                                        <img className="img-fluid" src={attachment.url} alt="" />
                                                                                    </a>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                ))
                                                            ))
                                                        }

                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </>
                )}

            </React.Fragment>

        </>
    )
}


CourseDetail.propTypes = {
    getCourseList: PropTypes.func.isRequired,
    courseSearch: PropTypes.func.isRequired,
    storeCourse: PropTypes.object.isRequired,
    courseRegister: PropTypes.func.isRequired,
    storeAds: PropTypes.object.isRequired,
    getAdsList: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    getCourseList: PropTypes.func.isRequired,
    courseSearch: PropTypes.func.isRequired,
    courseRegister: PropTypes.func.isRequired,
    storeCourse: state.course,
    getAdsList: PropTypes.func.isRequired,
    storeAds: state.ads,
});

export default connect(mapStateToProps, { getCourseList, courseSearch, getAdsList, courseRegister })(CourseDetail)